/**
 * Inline markdown: renders **bold** and `code` in a text string.
 *
 * Split out of `AgentTextSegment.tsx` (react-refresh/only-export-components).
 */

import type { ReactNode } from "react";

export function renderInlineMarkdown(text: string): ReactNode[] {
  const parts: ReactNode[] = [];
  const regex = /\*\*(.+?)\*\*|`(.+?)`/g;

  const lastIndex = Array.from(text.matchAll(regex)).reduce((index, match) => {
    const matchIndex = match.index ?? 0;
    if (matchIndex > index) parts.push(text.slice(index, matchIndex));
    if (match[1])
      parts.push(
        <strong key={matchIndex} className="font-semibold text-foreground">
          {match[1]}
        </strong>,
      );
    else if (match[2])
      parts.push(
        <code
          key={matchIndex}
          className="rounded bg-muted/50 px-1 py-0.5 font-mono text-[11px]"
        >
          {match[2]}
        </code>,
      );
    return matchIndex + match[0].length;
  }, 0);

  if (lastIndex < text.length) parts.push(text.slice(lastIndex));
  return parts.length > 0 ? parts : [text];
}
